import installCE from 'document-register-element/pony';

installCE(global, 'force-all');
